export {
  ReportsListComponent
} from "./reports-list/reports-list.component";
export {
  ReportDetailComponent
} from "./report-detail/report-detail.component";
